import { useState } from "react";

import { ChromePicker } from "react-color";

const styles = {
  swatch: {
    padding: "5px",
    background: "#fff",
    borderRadius: "1px",
    boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
    display: "inline-block",
    cursor: "pointer",
  },
  color: {
    width: "36px",
    height: "14px",
    borderRadius: "2px",
  },
  popover: {
    position: "absolute",
    zIndex: "2",
  },
  cover: {
    position: "fixed",
    top: "0px",
    right: "0px",
    bottom: "0px",
    left: "0px",
  },
};

const ColorPicker = ({ field, watch, setValue }) => {
  const [showPicker, setShowPicker] = useState(false);
  const color = watch(field.name);

  return (
    <div>
      <div
        style={styles.swatch}
        onClick={() => setShowPicker((oldVal) => !oldVal)}
      >
        <div style={{ ...styles.color, background: color?.hex || "white" }} />
      </div>
      {showPicker && (
        <div style={styles.popover}>
          <div style={styles.cover} onClick={() => setShowPicker(false)} />
          <ChromePicker
            disableAlpha
            color={color}
            onChange={(color) => setValue(field.name, color)}
          />
        </div>
      )}
    </div>
  );
};

export default ColorPicker;
